import React from "react";
import styles from "./document.module.css";
import backgroundImage from "./../../assets/16.09.2022-2-1-2.jpg";

export const Shinagana = () => {
  const documentList = [
    {
      name: "სკოლის სტრატეგიული განვითარების 7 წლიანი  გეგმა",
      filename: "shvidwliani.pdf",
    },
    {
      name: "ერთწლიანი სამოქმედო გეგმა 2025-2026 სასწ.წ.",
      filename: "ertwlianisamoqmedo1.pdf",
    },
    {
      name: "სკოლის ერთწლიანი სამოქმედო გეგმა 2023-2024",
      filename: "skolis_ertwliani_samoqmedo_gegma_2023-2024.pdf",
    },
    {
      name: "ერთწლიანი სამოქმედო გეგმა 2024-2025 სასწ.წ.",
      filename: "2024-2025samoqmedo.pdf",
    },

    {
      name: "2024-25 სამოქმედო გეგმის მონიტორინგის ანგარიში",
      filename: "monitoringi.pdf",
    },
    {
      name: "სკოლის 6 წლიანი გეგმა 2020-2026 წ.",
      filename: "eqvswliani2020-2026.pdf",
    },
    {
      name: "6 წლიანი სამოქმ. გეგმის შუალედური ანგარიში",
      filename: "gegmis-angarishi.pdf",
    },
  ];

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    height: "100vh",
  };

  return (
    <div style={backgroundStyle}>
      <div className={styles.documentsPage}>
        <header className={styles.header}>
          <h1>სამოქმედო გეგმა</h1>
        </header>
        <div className={styles.documentsContainer}>
          {documentList.map((doc, index) => (
            <a
              key={index}
              className={styles.documentBox}
              target="_blank"
              rel="noreferrer noopener"
              href={`https://batumi-gimnazia.edu.ge/documents/${doc.filename}`}
            >
              {doc.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
